import type { Module } from "@webmotors/ioc";
import { LoggerModule } from "../logger";
import { LocalStorageService } from "./local-storage.service";

export const LocalStorageModule: Module = {
  name: "LocalStorageModule",
  modules: [LoggerModule],
  providers: [LocalStorageService],
};
